export const computeOwnerURL = ({ key }) => {
    const keyword = key;
    return ["cars", "no-of-owners", keyword];
};
